export var getPropOnCondition = function getPropOnCondition(prop, condition) {
  return condition ? prop : undefined;
};